export function isHttpOrHttpsUrl(input: string): boolean {
  const value = input?.trim?.();
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === 'http:' || url.protocol === 'https:';
  } catch {
    return false;
  }
}
